import { TRESPONSE_MASTER_DATA } from '@monorepo/types';
import { normalize, schema } from 'normalizr';
import { MasterDataDBTypes } from './master-data-db.reducer';

const bundles = new schema.Entity(MasterDataDBTypes.BUNDLES, undefined, {
  idAttribute: (value) => value.req_id,
});

export const getNormalizedData = (originalData: TRESPONSE_MASTER_DATA['response']) => {
  return normalize(originalData, [bundles]) as any;
};
